import {list} from "custom/demo/requests/admin/admins";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {list};

const columns = [
  {key: "email", label: "Email"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Admin" path="/admin/admins" />;
}
